// 변경 신청·변경 승인·GPU 승인 창의 select(VM 생성 페이지는 `components/Choice.tsx`). 같은 모양을 쓰므로 문자열은 여기 한 곳에만 있다 —
// 자리마다 적으면 한 자리만 바뀐다. 글자가 16px 미만이면 포커스 때 화면이 확대된다 — 좁은 화면에서만 키운다.
export const SELECT = 'h-9 rounded-md border border-input bg-background px-2 text-base sm:text-sm'
